import { apiMutationKeys } from '@/services/apis/apiMutationKeys';
import { getQuoteSummary } from '@/services/apis/getQuoteSummary';
import { useGlobalStore } from '@/stores/store';
import { createMobileOfferPayload } from '@/utils/quote-summary';
import { getGlobalStore } from '@/utils/store';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

export function useRemoveBroadbandOffer() {
  const latestMobileOffer = useGlobalStore(
    (store) => store.shoppingCartStore.latestMobileOffer
  );

  const { setLatestNewDevelopmentCharge, setLatestBroadbandOffer } =
    getGlobalStore();
  const { mutate } = useMutation({
    mutationFn: getQuoteSummary,
    mutationKey: [...apiMutationKeys.getQuoteSummary],
  });

  //NOTE: This function removes the broadband offer from the cart in a silent way
  // in case the user has already added the broadband offer to shopping cart and runs the Quote Summary mutation
  // just if there is a mobile offer(to recalculate the quote)
  const removeBroadbandOffer = useCallback(() => {
    setLatestNewDevelopmentCharge(null);
    setLatestBroadbandOffer(null);

    //NOTE: If the mobile offer is still on the cart, we need to run the quote summary mutation with mobile offer because it's still on the cart
    if (latestMobileOffer) {
      // Silent mutation - we don't need to show any UI for loading/error state
      const mobileOfferPayload = createMobileOfferPayload(latestMobileOffer.id);
      mutate({
        quoteSummaryRequest: {
          ...mobileOfferPayload,
        },
      });
    }
  }, [
    latestMobileOffer,
    setLatestBroadbandOffer,
    setLatestNewDevelopmentCharge,
    mutate,
  ]);

  return removeBroadbandOffer;
}
